import { combineReducers } from 'redux'
import token from './token/reducer'
import user from './user/reducer'
import repositories from './repositories/reducer'
import errors from './errors/reducer'
import organizations from './organizations/reducer'
import loading from './loading/reducer'
import branches from './branches/reducer'
import files from './files/reducer'
import uncommitted from './uncommitted/reducer'

const reducer = combineReducers({
  token,
  user,
  repositories,
  errors,
  organizations,
  loading,
  branches,
  files,
  uncommitted,
})

export default function(state, action){
  if (action.type == 'LOGOUT')
    state = {}
  if (action.type == 'BATCH_ACTIONS'){
    const { actions } = action.payload
    return actions.reduce((state, action) => reducer(state, action), state)
  }
  return reducer(state, action)
}


// WEBPACK FOOTER //
// ./src/store/reducer.js